import { Vue, Component } from 'vue-property-decorator'
import {
	RemoteErgRaceState, remoteErgRaceStates, RemoteErgRaceStatus, RaceDefinition, RemoteErgStatusMsg
} from 'shared/types/erg'

import { makeComputedBinding } from 'shared/util'


@Component
class RemoteErgModule extends Vue {

	state: RemoteErgRaceState = 'ready'
	raceFiles: any = []
	resultsFiles: any = null
	ergMap: any = null
	ergStatus: any = null
	statusSummary: RemoteErgStatusMsg[] = []
	race: RaceDefinition = {
		name_long: '',
		name_short: '',
		event_name: '',
		duration: 2000,
		duration_type:  'meters',
		race_type: 'individual',
		time_cap: 0,
		split_value: 0,
		boats: []
	}

	public setStatus(s: RemoteErgRaceStatus) {
		if (!Object.values(remoteErgRaceStates).includes(s.state)) { throw new Error('Invalid state: ' + s) }
		this.state = s.state
		switch (s.state) {
			case 'sent_races':
			this.raceFiles = s.detail.races
			break
		case 'loaded_erg_map':
			this.ergMap = s.detail
		case 'sent_results':
			this.resultsFiles = s.detail
			break
		case 'status_summary_sent':
			this.statusSummary = s.detail.status
			break
		case 'loaded_race':
			if(s.detail.race_definition) { this.race = s.detail.race_definition }
		case 'erg_status_sent':
			this.ergStatus = s.detail.erg_status
			break
		case 'cleared_erg_map':
			this.ergStatus = []
		case 'saved_loaded':
			if(s.detail.race_definition) { this.race = s.detail.race_definition }
		default:
			break
		}
	}
}

export const RemoteErg = new RemoteErgModule()
export const RemoteErgState = makeComputedBinding(RemoteErg)
